<template>
  <el-submenu index="Comn_overview" v-if="canShowSubMenuItem">
    <span slot="title">{{ $t("Comn_overview") }}</span>
    <router-link
      v-for="(item, key) in filterMenuItemsByPermissions"
      :key="key"
      :to="item.route"
      class="menu-item-wrapper"
    >
      <li
        class="el-menu-item"
        :index="item.langKey"
        :route="item.route"
        :class="{ 'is-active': $route.meta.langKey === item.langKey }"
      >
        <img class="menu-image" :src="renderMenuIcon(item.imgKey)" />
        <p class="menu-title truncate" v-if="getSideNavStatus">
          {{ $t(item.langKey) }}
        </p>
      </li>
    </router-link>
  </el-submenu>
</template>

<script>
import { mapGetters } from "vuex";
import renderMenuIcon from "./renderMenuIcon";
import { permissionsToStringMap as permissions } from "@/middleware/pageAccessManager";

export default {
  computed: {
    ...mapGetters("header", {
      getSideNavStatus: "getSideNavStatus"
    }),
    menuItems: function() {
      return {
        DASHBOARD: {
          langKey: "Comn_dashboard",
          route: "/user/dashboard?tab=dashboardTab",
          imgKey: "DASHBOARD",
          keyToValidateAccess: "PERMISSIONS",
          PERMISSIONS: [
            permissions.MANAGE_OVERVIEW,
            permissions.MANAGE_CULTURE,
            permissions.MANAGE_DEVICES,
            permissions.MANAGE_ABW,
            permissions.MANAGE_HARVEST
          ]
        },
        MAPS: {
          langKey: "Comn_map",
          route: "/user/map-view",
          imgKey: "MAPS",
          keyToValidateAccess: "PERMISSIONS",
          PERMISSIONS: [permissions.MANAGE_CULTURE, permissions.MANAGE_DEVICES]
        },
        PONDS: {
          langKey: "Comn_ponds",
          route: "/user/pond-details",
          imgKey: "PONDS",
          keyToValidateAccess: "PERMISSIONS",
          PERMISSIONS: [
            permissions.MANAGE_ABW,
            permissions.MANAGE_CULTURE,
            permissions.MANAGE_SCHEDULES,
            permissions.MANAGE_MEDICINE,
            permissions.MANAGE_LAB_TESTS
          ]
        },
        BATTERY: {
          langKey: "Comn_battery",
          route: "/user/battery",
          imgKey: "BATTERY",
          keyToValidateAccess: "PERMISSIONS",
          PERMISSIONS: [permissions.MANAGE_CULTURE, permissions.MANAGE_DEVICES]
        }
      };
    },
    filterMenuItemsByPermissions: function() {
      return this.itemsUserCanView(this.menuItems);
    },
    canShowSubMenuItem: function() {
      return Object.keys(this.filterMenuItemsByPermissions).length > 0;
    }
  },
  methods: {
    renderMenuIcon
  }
};
</script>

<style></style>
